//#region import
import React, { useEffect, useState } from 'react';
import { Button, Card, Grid, Tooltip, Typography } from '@mui/material';
import { FnAxios, FnDialog, I18n, formatNumber } from 'utilities/utilities';
import { BtnClear, BtnExportExcel, BtnSearch, BtnSendRequest, BtnVersion } from 'components/Button/ButtonAll';
import { APIStatusCode, EnumRegisterTimelineType, I18NextNs } from 'enum/enum';
import { useLocation, useNavigate } from 'react-router';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { FormProvider, useForm } from 'react-hook-form';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { BtnEditOnTable, BtnUpdateDataOnTable, BtnVersionOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import { ApiProject } from 'enum/api';
import { TextBoxItem } from 'components/Input/TextBox';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { List as LINQ } from "linqts";
import ModalExtendPeriod from './Modal/ModalExtendPeriod';
import ModalCommittee from './Modal/ModalCommittee';
import { DashboardCustomize, } from '@mui/icons-material';
import moment from 'moment';
//#endregion

const ProjectCheckRecordFastTrack = () => { //ตรวจสอบ/บันทึกผล >> เร่งด่วน
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const DialogFn = FnDialog();
    const location = useLocation();

    const [isPermission, setPermission] = useState<boolean>(true); //false // Permission true = Edit | false = View, Disabled
    const [loadingTable, setLoadingTable] = useState(false);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        arrRows: []
    });
    const [arrDataStatusID, setarrDataStatusID] = useState<any>([]);
    const [arrDataSectionTypeID, setarrDataSectionTypeID] = useState<any>([]);
    const [lstDataProjectCheckRecord, setlstDataProjectCheckRecord] = useState([]);
    const [isExportExcel, setisExportExcel] = useState(false); //ปุ่ม Export Excel File > เปิดตอนเป็น เลขา และ Admin เท่านั้น
    // const [isBtnSendCommittee, setisBtnSendCommittee] = useState(false); //ปุ่ม ส่งคณะกรรมการบริหารกองทุนฯ > เปิดตอนเป็น เลขา
    const [isSecretary, setisSecretary] = useState(false); //เลขา    

    const currentDate = new Date(); // Get the current date
    const _dStart = new Date(currentDate.getFullYear(), 0, 1); //01/01/New
    const _dEnd = new Date(currentDate.getFullYear(), 12, 0); //31/12/New

    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sProjectName_FastTrack: null,
            arrSectionTypeID_FastTrack: null,
            arrStatusID_FastTrack: null,
            //วันที่อนุมัติโครงการ
            dStartDate_FastTrack: null, //_dStart,
            dEndDate_FastTrack: null, //_dEnd,
            //วันที่ยื่นโครงการ
            dStartDateRegister_FastTrack: null, //_dStart, 
            dEndDateRegister_FastTrack: null, //_dEnd,
        } as any,
    });

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
        GetFormInitialList();
    }, []);

    const GetFormInitialList = () => {
        AxiosFn.Get(ApiProject.GetFormInitialCheckRecordFastTrack, {}, (result) => {
            setisExportExcel(result.isExportExcel);
            // setisBtnSendCommittee(result.isBtnSendCommittee);
            setisSecretary(result.isSecretary);
            setarrDataSectionTypeID(result.lstSectionTypeID);
            form.setValue("arrSectionTypeID_FastTrack", result.lstSectionTypeID.map(m => m.value));
            setarrDataStatusID(result.lstStatusID);
            form.setValue("arrStatusID_FastTrack", result.lstStatusID.map(m => m.value));
            handleGetTableProject(dataRow);
        });
    }

    const handleGetTableProject = (p: PaginationInterface) => {
        setLoadingTable(true);
        let ObjForm = form.getValues();
        let nDate_Start = ObjForm.dStartDate_FastTrack ? ObjForm.dStartDate_FastTrack.valueOf() : null;
        let nDate_End = ObjForm.dEndDate_FastTrack ? ObjForm.dEndDate_FastTrack.valueOf() : null;
        let nDate_StartRegister = ObjForm.dStartDateRegister_FastTrack ? ObjForm.dStartDateRegister_FastTrack.valueOf() : null;
        let nDate_EndRegister = ObjForm.dEndDateRegister_FastTrack ? ObjForm.dEndDateRegister_FastTrack.valueOf() : null;
        let objParam = {
            ...p,
            sProjectName: ObjForm.sProjectName_FastTrack ?? null,
            lstSectionTypeID: ObjForm.arrSectionTypeID_FastTrack ?? [],
            lstStatusID: ObjForm.arrStatusID_FastTrack ?? [],
            //วันที่อนุมัติโครงการ
            nStartDate: nDate_Start,
            nEndDate: nDate_End,
            //วันที่ยื่นโครงการ
            nStartDateRegister: nDate_StartRegister,
            nEndDateRegister: nDate_EndRegister,
        };
        AxiosFn.Post(ApiProject.GetTableCheckRecordFastTrack, objParam, (result) => {
            setLoadingTable(false);
            if (result.nStatusCode === APIStatusCode.Success) {
                setlstDataProjectCheckRecord(result.lstDataProjectCheckRecord ?? []);
                setDataRow({
                    ...p,
                    arrRows: result.lstDataProjectCheckRecord ?? [],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,
                });
            } else {
                DialogFn.Warning(result.sMessage);
            }
        });
    };

    const goToEdit = (sID: string, sMode: string) => {
        let sUrl = "/ProjectCheckRecordFrom";
        navigate(sUrl, { state: { sID: sID, sMode: sMode, sRegisterTimelineType: EnumRegisterTimelineType.FastTrack, sModeSecretary: (sMode === "Update" ? false : isSecretary), sPathNameBack: "/ProjectCheckRecordList" } });
    };

    const dataColumn: any = [
        {
            field: "isBtnEdit",
            headerName: `${I18n.SetText("Project.sManagement")}`,
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            disableReorder: true,
            width: 80,
            getActions: (item) => {
                return [
                    <>
                        {isPermission ? 
                            <>
                                {/* {item.row.isBtnUpdate &&
                                    <BtnUpdateDataOnTable
                                        key={item.row.sID}
                                        id="btnUpdate"
                                        txt={"ลงคะแนน"}
                                        icon={<TaskAlt/>}
                                        onClick={() => goToEdit(item.row.nProjectID, "Update" )}
                                        IsDisabled={!isPermission}
                                    />
                                } */}
                                {item.row.isBtnEdit ?
                                    <BtnEditOnTable
                                        key={item.row.sID}
                                        id="btnEdit"
                                        onClick={() => goToEdit(item.row.nProjectID, "Edit")}
                                        IsDisabled={!isPermission}
                                    />
                                    :
                                    <BtnViewDataOnTable
                                        key={item.row.sID}
                                        id="btnView"
                                        onClick={() => goToEdit(item.row.nProjectID, "View")}
                                    // IsDisabled={isPermission}
                                    />
                                }
                            </>
                        : 
                            <BtnViewDataOnTable
                                key={item.row.sID}
                                id="btnView"
                                onClick={() => goToEdit(item.row.nProjectID, "View")}
                                // IsDisabled={isPermission}
                            />                        
                        }
                    </>
                ];

            },
        },
        {
            field: "sStatusTableName", //field: "sStatusName",
            headerName: `${I18n.SetText("Project.sStatus")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 3,
            // renderCell: (item) => {
            //     return (item.row.nProgressStatusID ? item.row.sProgressStatus : item.row.sStatusName);
            // }
        },
        {
            field: "sProjectName",
            headerName: `${I18n.SetText("Project.sProjectName")}`,
            headerAlign: "center",
            align: "left",
            sortable: true,
            disableReorder: true,
            flex: 5,
            renderCell: (item) => {
                return (
                    <Grid item container spacing={1} xs={12} md={12} justifyContent={'space-between'}>
                        <Grid item >
                            <span>{item.row.sProjectName}</span>
                        </Grid>
                        {(item.row.lstExtendPeriod || []).length > 0 &&
                            <Grid item>
                                {/* <Tooltip title={'ประวัติการดำเนินการขยายระยะเวลา'} >
                                    <DashboardCustomize
                                        sx={{
                                            color: "#930012 !important",
                                            "&:hover": {
                                                color: "#063b9f !important",
                                            },
                                            cursor: "pointer",
                                        }}
                                        // titleAccess='ประวัติการดำเนินการขยายระยะเวลา'
                                        onClick={() => onOpenModalExtendPeriod(item.row.lstExtendPeriod)}
                                    />
                                </Tooltip> */}
                                <BtnVersionOnTable id={"BtnVersion"} txt={'ประวัติการดำเนินการขยายระยะเวลา'} IsCircleWithOutText={true} onClick={() => onOpenModalExtendPeriod(item.row.lstExtendPeriod)} />
                            </Grid>
                        }
                    </Grid>
                );
            },
        },
        {
            field: "sProjectOwner",
            headerName: `${I18n.SetText("Project.sProjectOwner")}`,
            headerAlign: "center",
            align: "left",
            sortable: true,
            disableReorder: true,
            flex: 3,
        },
        {
            field: "nProjectYear",
            headerName: `${I18n.SetText("Project.sProjectYear")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            // flex: 1,
            width: 60,
        },
        {
            field: "sSectionType",
            headerName: `${I18n.SetText("Project.sProjectType")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 2,
        },
        {
            field: "nBudgetPlan",
            headerName: `${I18n.SetText("Project.sBudgetPlan")}`,
            headerAlign: "center",
            align: "right",
            sortable: true,
            disableReorder: true,
            flex: 2,
            renderCell: (item) => {
                return (formatNumber(item.row.nBudgetPlan, 2));
            },
        },
        {
            field: "nBudgetReallySpend",
            headerName: `${I18n.SetText("Project.sBudgetReallySpend")}`,
            headerAlign: "center",
            align: "right",
            sortable: true,
            disableReorder: true,
            flex: 2,
            renderCell: (item) => {
                return (formatNumber(item.row.nBudgetReallySpend, 2));
            },
        },
        {
            field: "sRegisterDate",
            headerName: `${I18n.SetText("Project.sDateRegister")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 2,
        },
        {
            field: "sApproveDate",
            headerName: `${I18n.SetText("Project.sDateApprover")}`,
            headerAlign: "center",
            align: "center",
            sortable: true,
            disableReorder: true,
            flex: 2,
        },
    ];

    const [isOpenExtendPeriod, setisOpenExtendPeriod] = useState(false); //Pop Up > ประวัติการดำเนินการขยายระยะเวลา และปรับแผนโครงการ
    const [lstExtendPeriod, setlstExtendPeriod] = useState(null);
    const onOpenModalExtendPeriod = (_lstExtendPeriod) => {
        setisOpenExtendPeriod(true);
        setlstExtendPeriod(_lstExtendPeriod);
    };

    // const [isOpenCommittee, setisOpenCommittee] = useState(false); //Pop Up > ส่งคณะกรรมการบริหารกองทุนฯ > เปิดตอนเป็น เลขา
    // const [ObjDataCommittee, setObjDataCommittee] = useState(null);   
    // const onOpenModalCommittee = () => {
    //     setisOpenCommittee(true);        
    //     AxiosFn.Get(ApiProject.GetFormCommitteeNormal, {}, (result) => {
    //         // setObjDataCommittee(res.ObjDataCommittee || []);
    //     });
    // };

    const onExportExcel = () => { //Export Excel Fil > เปิดตอนเป็น เลขา และ Admin        
        DialogFn.BlockUI();
        let nYearThai = parseInt(moment().format('YYYY')) + 543;
        let sFileName = `ข้อมูลโครงการ_เร่งด่วน_${moment().format('DMMM')}${nYearThai}.xlsx`;

        let ObjForm = form.getValues();
        let nDate_Start = ObjForm.dStartDate_FastTrack ? ObjForm.dStartDate_FastTrack.valueOf() : null;
        let nDate_End = ObjForm.dEndDate_FastTrack ? ObjForm.dEndDate_FastTrack.valueOf() : null;
        let nDate_StartRegister = ObjForm.dStartDateRegister_FastTrack ? ObjForm.dStartDateRegister_FastTrack.valueOf() : null;
        let nDate_EndRegister = ObjForm.dEndDateRegister_FastTrack ? ObjForm.dEndDateRegister_FastTrack.valueOf() : null;

        let param = {
            isFastTrack: true,
            sProjectName: ObjForm.sProjectName_FastTrack ?? null,
            lstSectionTypeID: ObjForm.arrSectionTypeID_FastTrack ?? [],
            lstStatusID: ObjForm.arrStatusID_FastTrack ?? [],
            //วันที่อนุมัติโครงการ
            nStartDate: nDate_Start,
            nEndDate: nDate_End,
            //วันที่ยื่นโครงการ
            nStartDateRegister: nDate_StartRegister,
            nEndDateRegister: nDate_EndRegister,
        }
        AxiosFn.DowloadFileBlob(ApiProject.ExportProjectExcelList, param, sFileName, () => {
            DialogFn.UnBlockUI();
        });
    }

    return (
        <Grid item container spacing={2} xs={12} md={12} style={{ padding: '1%', }} >
            <FormProvider {...form}>
                <Grid item container spacing={2} xs={12} md={12} justifyContent={'flex-start'} justifyItems={'flex-start'} alignItems={'center'}>
                    {isExportExcel &&
                        <Grid item>
                            <BtnExportExcel id={'btnExportExcel_FastTrack'} onClick={() => { onExportExcel(); }} /> {/* txt={'Export Excel File'}  */}
                        </Grid>
                    }
                    {/* {isBtnSendCommittee &&
                        <Grid item>
                            <BtnSendRequest id={'btnSend_FastTrack'} txt={'ส่งคณะกรรมการบริหารกองทุนฯ'} bgcolorHover={'#3759b3'} bgcolor={'#4466bf'} onClick={()=> { onOpenModalCommittee(); }} />
                        </Grid>
                    } */}
                </Grid>
                <Grid item container spacing={2} xs={12} md={12} justifyItems={'end'} justifyContent={'end'} alignItems={'center'}>
                    <Grid item xs={12} md={4}>
                        <TextBoxItem
                            id={"sProjectName_FastTrack"}
                            name={"sProjectName_FastTrack"}
                            label={`${I18n.SetText("Project.sProjectName")}`}
                            required={false}
                            maxLength={250}
                        />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <MultipleSelectItem
                            id={"arrSectionTypeID_FastTrack"}
                            name={"arrSectionTypeID_FastTrack"}
                            label={`${I18n.SetText("Project.sProjectType")}`}
                            required={false}
                            options={arrDataSectionTypeID}
                            disabled={false}
                            limitTag={1}
                        />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <MultipleSelectItem
                            id={"arrStatusID_FastTrack"}
                            name={"arrStatusID_FastTrack"}
                            label={`${I18n.SetText("Project.sStatus")}`}
                            required={false}
                            options={arrDataStatusID}
                            disabled={false}
                            limitTag={1}
                        />
                    </Grid>
                    <Grid item xs={12} md={5} container spacing={1}>
                        <Grid item xs={11} md={5.8}>
                            <DatePickerItem
                                name={"dStartDateRegister_FastTrack"}
                                id={"dStartDateRegister_FastTrack"}
                                label={`${I18n.SetText("Project.sStartDateRegister")}`}
                                fullWidth={true}
                                required={false}
                                disabled={false}
                                maxDate={form.watch("dEndDateRegister_FastTrack")}
                            />
                        </Grid>
                        <Grid item style={{ marginTop: '2%' }}> - </Grid>
                        <Grid item xs={11} md={5.8}>
                            <DatePickerItem
                                name={"dEndDateRegister_FastTrack"}
                                id={"dEndDateRegister_FastTrack"}
                                label={`${I18n.SetText("Project.sEndDate")}`}
                                fullWidth={true}
                                required={false}
                                disabled={false}
                                minDate={form.watch("dStartDateRegister_FastTrack")}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={5} container spacing={1}>
                        <Grid item xs={11} md={5.8}>
                            <DatePickerItem
                                name={"dStartDate_FastTrack"}
                                id={"dStartDate_FastTrack"}
                                label={`${I18n.SetText("Project.sStartDate")}`}
                                fullWidth={true}
                                required={false}
                                disabled={false}
                                maxDate={form.watch("dEndDate_FastTrack")}
                            />
                        </Grid>
                        <Grid item style={{ marginTop: '2%' }}> - </Grid>
                        <Grid item xs={11} md={5.8}>
                            <DatePickerItem
                                name={"dEndDate_FastTrack"}
                                id={"dEndDate_FastTrack"}
                                label={`${I18n.SetText("Project.sEndDate")}`}
                                fullWidth={true}
                                required={false}
                                disabled={false}
                                minDate={form.watch("dStartDate_FastTrack")}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={1.2} container spacing={1} justifyItems={'end'} justifyContent={'flex-start'}>
                        <Grid item>
                            <BtnClear
                                id={'btnClearSearchAll_FastTrack'}
                                IsCircleWithOutText={true}
                                onClick={() => {
                                    form.reset();
                                    form.setValue("arrSectionTypeID_FastTrack", arrDataSectionTypeID.map(m => m.value));
                                    form.setValue("arrStatusID_FastTrack", arrDataStatusID.map(m => m.value));
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <BtnSearch id={'btnSearchAll_FastTrack'} IsCircleWithOutText={true} onClick={() => { handleGetTableProject(dataRow); }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ mt: 1 }}>
                    <DataGrid
                        sTableID='TB_Project_FastTrack'
                        isLoading={loadingTable}
                        columns={dataColumn}
                        rows={dataRow}
                        onLoadData={(e) => { handleGetTableProject(e) }}
                        isHiddenToolHead={true}
                        isShowCheckBox={false}
                    />
                </Grid>
            </FormProvider>

            <ModalExtendPeriod isOpen={isOpenExtendPeriod} setIsOpen={setisOpenExtendPeriod} lstDataAll={lstExtendPeriod} />
            {/* <ModalCommittee isOpen={isOpenCommittee} setIsOpen={setisOpenCommittee} ObjData={ObjDataCommittee} /> */}
        </Grid>
    )
}
export default ProjectCheckRecordFastTrack;
